import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Meshing } from '@usimweb/core/models';
import { VtkStlReader } from '@usimweb/core/services';

import { AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';

import { MatDialogRef } from '@angular/material/dialog';
import { Dialog } from '@usimweb/ui/dialogs';
import { CubeService } from '../../core/services/cube-service/cube-service';

@Component({
    selector: 'app-add-cad-dialog',
    templateUrl: './add-cad-dialog.component.html',
    styleUrls: ['./add-cad-dialog.component.scss'],
    standalone: false
})
export class AddCadDialogComponent extends Dialog implements OnInit {
  @Input() data = { uuid: '' };

  public appTypes = [{ key: '', value: '' }];
  public selectedFile: File = new File([], '');
  public fileName: string = '';
  public volume: string = '';

  public isImport = false;
  public saveBtn = 'Select';
  public preview: SafeUrl = '';
  public scale = '0';
  public meshing: any = {};

  public maxHCoarse = 3;
  public projectUuid: string = '';

  value: number = 1;
  options: Options = {
    showTicks: false,
    showTicksValues: true,
    stepsArray: [
      { value: 0, legend: 'Coarse' },
      { value: 1, legend: 'Medium' },
      { value: 2, legend: 'Fine' },
    ],
    translate: (value: number, label: LabelType): string => {
      switch (value) {
        case 1:
          return 'Refinement level surface';
        default:
          return '';
      }
    },
    ticksTooltip: (v: number): string => {
      return 'Set the fineness of the mesh on the edges...';
    },
  };

  constructor(
    private dialogRef: MatDialogRef<AddCadDialogComponent>,
    private apiService: ApiService,
    private domSanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private cubeService: CubeService
  ) {
    super();
  }

  ngOnInit() {
    VtkStlReader.isLoading = false;
    const subscription = this.apiService.getAppTypes().subscribe((result) => {
      subscription.unsubscribe();
      this.appTypes = result;
    });

    this.projectUuid = this.data.uuid;
  }

  private initCube(data: any) {
    let divElement = document.getElementById('renderDiv');
    if (divElement) {
      this.cubeService.initialize(divElement, data);
    }
  }

  public save() {
    VtkStlReader.isLoading = true;
    this.snackBar.open('Uploading model...', 'OK', { duration: 2000 });

    this.meshing.owner = AuthHandler.basfUserName;
    this.meshing.stlFile = this.selectedFile;
    this.meshing.project = this.projectUuid;

    console.log('saved meshing');
    console.log(this.meshing);

    const subscription = this.apiService.addMeshingObject(this.meshing).subscribe((response: Meshing) => {
      subscription.unsubscribe();
      VtkStlReader.isLoading = false;

      this.dialogRef.close({
        file: this.selectedFile,
        id: response.uuid,
        title: response.title,
        appType: response.appType,
      });
    });
  }

  public close() {
    this.dialogRef.close();
  }

  public get isLoading() {
    return VtkStlReader.isLoading;
  }

  public selectedAppType(event = { value: '' }) {
    const appType = event['value'];

    const subscription = this.apiService.getMeshingDefaultSettings(appType).subscribe((response: any) => {
      subscription.unsubscribe();

      console.log('response');
      console.log(response);

      this.scale = response['previewScale'];
      this.meshing = response.meshing;
      //this.meshing.title = '';
      this.meshing.appType = appType;
      this.preview = '';

      if (appType === 'porousBox') {
        this.isImport = true;
        setTimeout(() => {
          this.initCube(this.meshing);
        });
        return;
      }

      if (appType === 'pufoam_closed' || appType === 'pufoam_open') {
        this.isImport = true;
      } else {
        this.isImport = false;

        const subscriptionPrev = this.apiService.getTemplatePreview(appType).subscribe((response) => {
          subscriptionPrev.unsubscribe();
          this.preview = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(response as any));
        });

        const subscriptionPrevFile = this.apiService
          .getTemplatePreviewByFileType(appType, 'stl')
          .subscribe((response: any) => {
            subscriptionPrevFile.unsubscribe();
            this.selectedFile = response;
          });
      }
    });
  }

  public uploadFile(event: Event) {
    const target = event.target as HTMLInputElement;

    if (target) {
      const files = target.files as FileList;

      for (let i = 0; i < files.length; i++) {
        this.selectedFile = <File>files[i];
        this.meshing.modelKey = this.selectedFile.name;
        VtkStlReader.loadPolyDataFromFile(this.selectedFile, 'renderDiv');
      }
    }
  }

  // public meshSizeChanged(event: Event) {
  //   const value = (event.target as HTMLInputElement).value;
  //   const meshSize = parseFloat(value);

  //   if (this.meshing.refinementLevel) {
  //     this.maxHCoarse = 0.5 * this.meshing.refinementLevel * meshSize;
  //   }
  // }

  // public refinementLevelChanged(refinementLevel: number) {
  //   if (this.meshing.meshSize) {
  //     this.maxHCoarse = 0.5 * refinementLevel * this.meshing.meshSize;
  //   }
  // }

  public changedValue(value: any, key: any) {
    this.meshing[key].value = parseFloat(value);

    if (this.meshing.appType === 'porousBox') {
      this.cubeService.updateCube(this.meshing);
    }
  }

  public getValue(obj: any) {
    return obj.value;
  }
  public getName(obj: any) {
    return obj.unit ? obj.verbose_name + ' [' + obj.unit + ']' : obj.verbose_name;
  }

  public isArray(obj: any) {
    return Array.isArray(obj);
  }

  public isInputValue(obj: any) {
    if (typeof obj.value === 'object') {
      return true;
    }
    return false;
  }
}
